import React, { useEffect, useState } from 'react';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import PublicIcon from '@mui/icons-material/Public';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import ShieldIcon from '@mui/icons-material/Shield';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import '../CSS/styles.css';

const ServiceStatsCard = ({ customers, rides, drivers, cities, distance, safetyRating, avgWaitTime }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100); // Adding a slight delay for the animation
  }, []);

  return (
    <div className="service-stats-card">
      <div className={`card-content ${isVisible ? 'fade-in' : ''}`}>
        <div className={`stats primary-grid ${isVisible ? 'slide-up' : ''}`}>
          <div className="stat-item">
            <EmojiEmotionsIcon sx={{ color: '#FFD700' }} className="stat-icon" /> {/* Gold color */}
            <h2>{customers}</h2>
            <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>Happy Customers</p>
          </div>
          <div className="stat-item">
            <LocalTaxiIcon sx={{ color: '#FF6347' }} className="stat-icon" /> {/* Tomato color */}
            <h2>{rides}</h2>
            <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>Total Rides</p>
          </div>
          <div className="stat-item">
            <DriveEtaIcon sx={{ color: '#32CD32' }} className="stat-icon" /> {/* LimeGreen color */}
            <h2>{drivers}</h2>
            <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>Professional Drivers</p>
          </div>
          <div className="stat-item">
            <PublicIcon sx={{ color: '#1E90FF' }} className="stat-icon" /> {/* DodgerBlue color */}
            <h2>{cities}</h2>
            <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>Cities Served</p>
          </div>
          <div className="stat-item">
            <AltRouteIcon sx={{ color: '#8A2BE2' }} className="stat-icon" /> {/* BlueViolet color */}
            <h2>{distance} km</h2>
            <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>Total Distance</p>
          </div>
        </div>
        <div className={`stats secondary-grid ${isVisible ? 'slide-in' : ''}`}>
          <div className="stat-item">
            <ShieldIcon sx={{ color: '#FFD700' }} className="stat-icon" /> {/* Gold color */}
            <h2>{safetyRating}/5</h2>
            <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>Safety Rating</p>
          </div>
          <div className="stat-item">
            <AccessTimeIcon sx={{ color: '#FF4500' }} className="stat-icon" /> {/* OrangeRed color */}
            <h2>{avgWaitTime} min</h2>
            <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>Average Wait Time</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceStatsCard;
